import restApi from '@/services/api/restApi'

// Admin Authentication & User Management
export const adminLoginFn = async (form_data) => {
  const response = await restApi.post(`/backend/admin/login`, form_data)
  return response.data
}

export const registerNewAdminUserFn = async (form_data) => {
  const response = await restApi.post(`/backend/admin/register`, form_data)
  return response.data
}

export const isAdminEmailAvailableFn = async (form_data) => {
  const response = await restApi.post(`/backend/admin/is_email_available`, form_data)
  return response.data
}

export const adminLogoutFn = async () => {
  const response = await restApi.post(`/backend/admin/logout`)
  return response.data
}

export const getAdminInfoFn = async () => {
  const response = await restApi.get(`/backend/admin/info`)
  return response.data
}

export const updateAdminEmailFn = async (form_data) => {
  const response = await restApi.post(`/backend/admin/settings/change_email`, form_data)
  return response.data
}

export const updateAdminInfoFn = async (form_data) => {
  const response = await restApi.post(`/backend/admin/settings/update_info`, form_data)
  return response.data
}

export const changeAdminPasswordFn = async (form_data) => {
  const response = await restApi.post(`/backend/admin/settings/change_password`, form_data)
  return response.data
}

export const adminForgotPasswordFn = async (form_data) => {
  const response = await restApi.post(`/backend/admin/forgot_password`, form_data)
  return response.data
}

export const adminVerifyTokenFn = async (form_data) => {
  const response = await restApi.post(`/backend/admin/password/verify_token`, form_data)
  return response.data
}

export const adminResetPasswordFn = async (form_data) => {
  const response = await restApi.post(`/backend/admin/password/reset`, form_data)
  return response.data
}

// Client Management
export const getAdminClientListFn = async (params) => {
  const query = new URLSearchParams(params).toString()
  const response = await restApi.get(`/backend/admin/client/list?${query}`)
  return response.data
}

export const getAdminClientDetailFn = async (client_id) => {
  const response = await restApi.get(`/backend/admin/client/${client_id}`)
  return response.data
}

export const getAdminClientRolesAndPermsFn = async () => {
  const response = await restApi.get(`/backend/admin/client/roles_and_perms`)
  return response.data
}

export const updateAdminClientPermsFn = async (client_id, form_data) => {
  const response = await restApi.post(`/backend/admin/client/${client_id}/edit_perms`, form_data)
  return response.data
}

// Restaurant Management
export const adminRestoListFn = async (params) => {
  const query = new URLSearchParams(params).toString()
  const response = await restApi.get(`/backend/admin/resto/list?${query}`)
  return response.data
}

// Order Management
export const orderListFn = async (current_page, resto_id) => {
  const response = await restApi.get(
    `/backend/admin/resto/${resto_id}/orders?&page=${current_page}`
  )
  return response.data
}

export const getOrderDetailFn = async (order_id, resto_id) => {
  const response = await restApi.get(`/backend/admin/resto/${resto_id}/order/${order_id}`)
  return response.data
}

export const getAdminAcceptRejectOrderOptionsFn = async (resto_id) => {
  const response = await restApi.get(
    `/backend/admin/resto/${resto_id}/accept_reject_order_options`
  )
  return response.data
}

export const acceptAdminOrderFn = async (resto_id, order_id, accept_time) => {
  let formData = new FormData()
  formData.append('accept_time', accept_time)
  const response = await restApi.post(
    `/backend/admin/resto/${resto_id}/order/${order_id}/accept`,
    formData
  )
  return response.data
}

export const rejectAdminOrderFn = async (resto_id, order_id, reject_reason) => {
  let formData = new FormData()
  formData.append('reject_reason', reject_reason)
  const response = await restApi.post(
    `/backend/admin/resto/${resto_id}/order/${order_id}/reject`,
    formData
  )
  return response.data
}

export const eposOrderListFn = async (current_page, resto_id) => {
  const response = await restApi.get(
    `/backend/admin/resto/${resto_id}/epos_orders?&page=${current_page}`
  )
  return response.data
}

export const getEposOrderDetailFn = async (order_id, resto_id) => {
  const response = await restApi.get(`/backend/admin/resto/${resto_id}/epos_order/${order_id}`)
  return response.data
}

// Edit Resto
export const editAdminRestoFn = async (resto_id, form_data) => {
  const response = await restApi.post(`/backend/admin/resto/${resto_id}/edit`, form_data)
  return response.data
}

// Get Admin Resto
export const getAdminRestoFn = async (resto_id, action) => {
  const response = await restApi.get(`/backend/admin/resto/${resto_id}/edit?get_data_action=${action}`)
  return response.data
}

// Get menu
export const getAdminMenuFn = async (resto_id, menu_type) => {
  const response = await restApi.get(`/backend/admin/resto/${resto_id}/menu/${menu_type}`)
  return response.data
}

// Get menu edit info
export const getAdminMenuEditInfoFn = async (resto_id, menu_id, action) => {
  const response = await restApi.get(`/backend/admin/resto/${resto_id}/edit_menu/${menu_id}?get_data_action=${action}`)
  return response.data
}

// Edit admin menu
export const editAdminMenuFn = async (resto_id, menu_id, form_data) => {
  const response = await restApi.post(`/backend/admin/resto/${resto_id}/edit_menu/${menu_id}`, form_data)
  return response.data
}

// Payment Management
export const getAdminPaymentListFn = async (resto_id) => {
  const response = await restApi.get(`/backend/admin/resto/${resto_id}/payments`)
  return response.data
}

export const getAdminPaymentDetailFn = async (resto_id, payment_id) => {
  const response = await restApi.get(`/backend/admin/resto/${resto_id}/payment/${payment_id}`)
  return response.data
}

// Reservation Management
export const getAdminReservationListFn = async (resto_id) => {
  const response = await restApi.get(`/backend/admin/resto/${resto_id}/reservations`)
  return response.data
}

export const getAdminReservationDetailFn = async (resto_id, reservation_id) => {
  const response = await restApi.get(`/backend/admin/resto/${resto_id}/reservation/${reservation_id}`)
  return response.data
}

export const updateAdminReservationFn = async (resto_id, reservation_id, form_data) => {
  const response = await restApi.post(`/backend/admin/resto/${resto_id}/reservation/${reservation_id}/edit`, form_data)
  return response.data
}

// Get meal and complex item
export const getMealAndComplexItemFn = async (resto_id, menu_id, category_id, item_id, product_id) => {
  const response = await restApi.get(`/backend/admin/resto/${resto_id}/edit_menu/${menu_id}?get_data_action=edit_product_item&category_id=${category_id}&item_id=${item_id}&product_id=${product_id}`)
  return response.data
}

export const downloadAdminContactListCsvFn = async (resto_id) => {
  const response = await restApi.get(`/backend/admin/resto/${resto_id}/download_contact_list_csv`, {
    responseType: 'blob'
  })
  return response
}

// Resto home analytics (see API docs: /analytics/*)
export const getAnalyticsTodayFn = async (resto_id) => {
  const response = await restApi.get(`/analytics/today/${resto_id}`)
  return response.data
}

export const getAnalyticsCompareFn = async (resto_id, params) => {
  const q = new URLSearchParams()
  if (params.a_start) q.set('a_start', params.a_start)
  if (params.a_end) q.set('a_end', params.a_end)
  if (params.b_start) q.set('b_start', params.b_start)
  if (params.b_end) q.set('b_end', params.b_end)
  if (params.source) q.set('source', params.source)
  const query = q.toString()
  const response = await restApi.get(
    `/analytics/compare/${resto_id}${query ? `?${query}` : ''}`
  )
  return response.data
}

export const getAnalyticsTrendFn = async (resto_id, params) => {
  const q = new URLSearchParams()
  if (params.start) q.set('start', params.start)
  if (params.end) q.set('end', params.end)
  if (params.source) q.set('source', params.source)
  const query = q.toString()
  const response = await restApi.get(`/analytics/trend/${resto_id}?${query}`)
  return response.data
}

export const getAnalyticsSummaryFn = async (resto_id, params) => {
  const q = new URLSearchParams()
  if (params.start) q.set('start', params.start)
  if (params.end) q.set('end', params.end)
  const query = q.toString()
  const response = await restApi.get(`/analytics/summary/${resto_id}?${query}`)
  return response.data
}

export const getAnalyticsHeatmapFn = async (resto_id, params) => {
  const q = new URLSearchParams()
  if (params.start) q.set('start', params.start)
  if (params.end) q.set('end', params.end)
  const query = q.toString()
  const response = await restApi.get(`/analytics/heatmap/${resto_id}?${query}`)
  return response.data
}

// Admin global analytics (all restos)
export const getAnalyticsTodayAllFn = async () => {
  const response = await restApi.get(`/analytics/today/all`)
  return response.data
}

export const getAnalyticsCompareAllFn = async (params) => {
  const q = new URLSearchParams()
  if (params.a_start) q.set('a_start', params.a_start)
  if (params.a_end) q.set('a_end', params.a_end)
  if (params.b_start) q.set('b_start', params.b_start)
  if (params.b_end) q.set('b_end', params.b_end)
  if (params.source) q.set('source', params.source)
  const query = q.toString()
  const response = await restApi.get(`/analytics/compare/all${query ? `?${query}` : ''}`)
  return response.data
}

export const getAnalyticsTopRestosFn = async (params) => {
  const q = new URLSearchParams()
  if (params.start) q.set('start', params.start)
  if (params.end) q.set('end', params.end)
  if (params.metric) q.set('metric', params.metric)
  if (params.limit) q.set('limit', String(params.limit))
  const query = q.toString()
  const response = await restApi.get(`/analytics/top-restos${query ? `?${query}` : ''}`)
  return response.data
}